import NotificationsController       from "@/js/Webmail/Notifications/NotificationsController";
import MessagesForwardingItem        from "./Collections/MessagesForwardingItem";
import MessagesForwardingHTTPMapping from "./HTTP/MessagesForwardingHTTPMapping";
import MessagesForwardingHTTPService from "./HTTP/MessagesForwardingHTTPService";
import Controller                    from "@/js/Shared/Controllers/Controller";


export { MessagesOptionsController as default };

/**
* Messages Forwarding Controller
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesForwardingControllerSingleton extends Controller {
  /**
   * Messages Forwarding item
   *
   * @public
   *
   * @type {MessagesForwardingItem}
   *
   * @since 7.0.0
   */
  item = new MessagesForwardingItem();

  /**
   * Messages Forwarding HTTP Mapping
   *
   * @private
   *
   * @type {MessagesForwardingHTTPMapping}
   *
   * @since 7.0.0
   */
  http_mapping = new MessagesForwardingHTTPMapping();

  /**
   * Messages Forwarding HTTP Service
   *
   * @private
   *
   * @type {MessagesForwardingHTTPService}
   *
   * @since 7.0.0
   */
  http_service = new MessagesForwardingHTTPService();

  /**
   * Makes an HTTP Request to fetch imap security options to the backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async fetchForwards() {
    this.content_state.setLoading();
    let response = await this.http_service.fetchForwards();

    this.content_state.setLoadedState(response.success);

    if (response.success === false) {
      NotificationsController.addMessage('notifications.', response.messages);
      return false;
    }

    this.http_mapping.map(this.item, response)

    return response.success;
  }

  /**
   * Saves messages options in APi Service
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<boolean>}
   */
  async saveForwards() {
    this.content_state.setSaving(true);
    let payload  = this.http_mapping.mapRequest(this.item);
    let response = (payload.forward.length > 0)
                 ? await this.http_service.saveForwards(payload)
                 : await this.http_service.deleteForwards(payload);
    this.content_state.setSaving(false);

    if (response.success === true) {
      this.http_mapping.map(this.item, response);
    }

    NotificationsController.addMessage('notifications.', response.messages);
    return response.success;
  }

  /**
   * Sets the Message options from a given object
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} options
   *
   * @return {void}
   */
    setOptions(options) {
      this.http_mapping.mapFromObject(this.options, options);
    }
}

/**
 * @type {MessagesForwardingControllerSingleton}
 */
const MessagesOptionsController = new MessagesForwardingControllerSingleton();